import { createFileRoute, redirect } from "@tanstack/react-router";

import { moduleApi } from "~/api";
import { BOILER_ROOM_MODULE_TYPES } from "~/features/module";

export const Route = createFileRoute("/_authenticated/buildings_/$buildingId/settings/bms/modules/")({
  loader: async ({ context: { queryClient }, params: { buildingId } }) => {
    const modules = await queryClient.ensureQueryData(moduleApi.queries.building(buildingId));
    const first = modules.find(md => BOILER_ROOM_MODULE_TYPES.includes(md.type));
    if (first) {
      throw redirect({
        to: "/buildings/$buildingId/settings/bms/modules/$moduleId",
        params: { buildingId, moduleId: first.id },
      });
    }
  },
  component: () => null,
});
